export const isNativeApp = () => window.Capacitor?.isNativePlatform?.() === true;
export const isIOS = () => window.Capacitor?.getPlatform?.() === 'ios';
export const isAndroid = () => window.Capacitor?.getPlatform?.() === 'android';

// True for any Apple mobile device (native iOS app, iOS Safari, Chrome iOS, iPad Safari).
// All iOS browsers are WebKit — same autoplay, fullscreen, and hardware-volume constraints apply.
export const isAppleMobile = () => {
  if (isIOS()) return true;
  const ua = typeof navigator !== 'undefined' ? navigator.userAgent || '' : '';
  if (/iPad|iPhone|iPod/.test(ua)) return true;
  // Modern iPad Safari reports as Mac; disambiguate via touch support.
  return ua.includes('Mac') && typeof document !== 'undefined' && 'ontouchend' in document;
};
